import React, { useEffect, useContext, useState } from 'react';
import { ApplicationContext } from '../../context/Application.context';
import { pdf } from '@react-pdf/renderer';
import { TypesContext } from '../../context/Types.context';
import { TemplateOTCQXUS, TemplateOTCQXBanks, TemplateOTCQB, TemplateDNS, TemplateOTCQXIntl } from '../../pdfTemplates/templates';
import Entity from '../Entity';

const DownloadAppPDF = ({ consoleOnly }) => {
  const [state] = useContext(ApplicationContext);
  const [typesState] = useContext(TypesContext);
  const [isDownloading, setDownloading] = useState(false);
  const application = state && state.application;
  const documents = state && state.documents;
  const owners = state && state.owners;
  const docTypes = typesState.docTypes;
  const appStatesTypes = typesState.appStates;
  const company = application.companyInfo.name;
  const appTypeName = application.typeDesc;
  const appTypeId = application.typeId;
  const downloadTitle = isDownloading ? 'Downloading...' : `Your Completed ${appTypeName} Application`;
  const subTitle = isDownloading ? '' : 'Download';
  const isOTCQXUS = appTypeId === 1;
  const isOTCQXBanks = appTypeId === 2;
  const isOTCQXIntl = appTypeId === 3;
  const isOTCQB = appTypeId === 4;
  const isDNS = application.typeId === 5;
  let PdfTemplate;

  if (isOTCQXUS) PdfTemplate = TemplateOTCQXUS;
  if (isOTCQXBanks) PdfTemplate = TemplateOTCQXBanks;
  if (isOTCQXIntl) PdfTemplate = TemplateOTCQXIntl;
  if (isOTCQB) PdfTemplate = TemplateOTCQB;
  if (isDNS) PdfTemplate = TemplateDNS;

  const handleDownload = async () => {
    const filename = `${appTypeName} - ${company}.pdf`;
    console.log('Downloading application as PDF:', filename);
    setDownloading(true);
    const blob = await pdf(
      <PdfTemplate docTypes={docTypes} application={application} documents={documents} owners={owners && owners} appStates={appStatesTypes} />
    ).toBlob();
    const link = document.createElement('a');
    // create a blobURI pointing to our Blob
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    // some browser needs the anchor to be in the doc
    document.body.append(link);
    link.click();
    link.remove();

    console.log('Download complete for:', filename);
    setDownloading(false);
  };


  useEffect(() => {
    // Expose only when this component is mounted
    window.downloadApplication = handleDownload;

    // Cleanup when page/component is no longer in view
    return () => {
      try {
        delete window.downloadApplication;
      } catch {
        // Fallback if delete fails
        window.downloadApplication = undefined;
      }
    };
  }, [handleDownload]);


  if (consoleOnly) return null;

  return (
    <Entity title={downloadTitle} onClick={handleDownload} icon='file' subTitle={subTitle} />
  );
};

export default DownloadAppPDF;
